import { Button, IconButton } from "@mui/material";
import { IoMdClose } from "react-icons/io";
import coinsImage from '../../Assets/img/odds/coins.png'
import React from "react";
import { createPortal } from "react-dom";

export default function ReferralSuccessModal({ bodyContent, onClose }) {
  return createPortal (
    <div className="fixed inset-0 bg-black/25 z-[999] flex items-center justify-center px-6 lg:px-0" onClick={onClose} >
      <div className="bg-white rounded-2xl shadow-md px-5 pt-5 pb-6 w-full max-w-sm mx-auto relative z-10">
        <div className="flex justify-end">
          <button onClick={onClose}> 
            <IoMdClose size={24} />
          </button>
        </div>

        <div className="flex items-center justify-center">
          <img src={coinsImage} alt="Coins" className="w-1/2" />
        </div>

        <div className="mt-4 mb-5 text-center">{bodyContent}</div>

        <div className="pt-2 ">
          <Button
            variant="contained"
            className="!bg-accent text-white w-full"
            sx={{
              padding: "12px 0",
              fontWeight: 600,
              boxShadow: "none",
              borderRadius: "6px",
            }}
          >
            Invite Another
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
}


